import type { SessionInfo } from '@dh-software/furnhome-types';
import type { FurnhomeCommunication } from '../interface/furnhome-communication';

export class BrowserFurnhomeCommunication implements FurnhomeCommunication {
  constructor(private apiUrl: string) {}

  public async checkSession(): Promise<SessionInfo> {
    try {
      const response = await fetch(`${this.apiUrl}/auth/checkSession`, { credentials: 'include' });

      // 403 heisst erkannt, aber nicht erlaubt - darauf darf nicht zur Anmeldung geschickt werden.
      if (response.status === 403) {
        // Erkannt, aber nicht erlaubt: die Sitzung besteht weiter, also kommen Name und
        // Kundennummer mit - die Sperrseite zeigt damit dieselbe Leiste wie sonst.
        const denied = await response.json().catch(() => ({}));
        return {
          authenticated: false,
          accessDenied: true,
          customerNo: String(denied.customerNo ?? ''),
          userName: String(denied.userName ?? ''),
          contactId: String(denied.contactId ?? ''),
          locale: String(denied.locale ?? ''),
          allowedModules: [],
          storeTree: [],
        };
      }

      if (!response.ok) {
        return { authenticated: false, accessDenied: false, customerNo: '', userName: '', contactId: '', locale: '', allowedModules: [], storeTree: [] };
      }

      const data = await response.json();
      return {
        authenticated: Boolean(data.authenticated),
        accessDenied: false,
        customerNo: String(data.customerNo ?? ''),
        userName: String(data.userName ?? ''),
        contactId: String(data.contactId ?? ''),
        locale: String(data.locale ?? ''),
        allowedModules: Array.isArray(data.allowedModules) ? data.allowedModules.map((moduleName: unknown) => String(moduleName)) : [],
        storeTree: Array.isArray(data.storeTree) ? data.storeTree : [],
      };
    } catch (error) {
      console.error('Unable to fetch session:', error);
      return { authenticated: false, accessDenied: false, customerNo: '', userName: '', contactId: '', locale: '', allowedModules: [], storeTree: [] };
    }
  }

  public getLoginUrl(originalUrl: string): string {
    return `${this.apiUrl}/auth/login?oriReq=${encodeURIComponent(originalUrl)}`;
  }

  public getStoreSwitchUrl(customerNumber: string, originalUrl: string): string {
    return `${this.apiUrl}/auth/switchStore?customerNumber=${encodeURIComponent(customerNumber)}&oriReq=${encodeURIComponent(originalUrl)}`;
  }

  public getLogoutUrl(): string {
    return `${this.apiUrl}/auth/logout`;
  }
}
